module.exports = __webpack_public_path__ + "img/correct-position.c0873bbb.png";